/*
Author: Vaishnavi
Date: 19/11/2019
Issue Description: Visual Bugs fixes assigned by Harshvardhan Kore & Tarun Bhandari,
spacing fixed in whole file. Used classes from margins.scss file
*/
/*
Author: Vaishnavi
Date: 05/12/2019
Issue No.: PL-2022
Issue Description: LWF deduction frequency and PT deduction frequency issue is resolved.
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: Without selecting state,able to see cities and select city from city dropdown.
search_string: PL_2023
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: In Lwf Settings validation required for Pincode.
search_string: PL_2027
*/

/*
Author: Srinivas P
Date: 05/12/2019
Issue Description: In Lwf Settings validation required for Pincode and not showing the validation message.
search_string: PL_2016
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: LWF deduction frequency.
search_string: PL_2022
*/

/*
Author: Vinod
Date: 05/12//2019
Issue Description: While Changing State, in City still showing previous state city.
search_string: PL_2335
*/

/*
Author: Vinod
Date: 03/01//2020
Issue Description: text change in LWF Pincode alert message.
search_string: PL_2353
*/

/*
Author: Vinod
Date: 08/01//2020
Issue Description: text change in LWF Pincode alert message.
search_string: PL_2380
*/

/*
Author: Vinod
Date: 10/01//2020
Issue Description: When ever Creating Location with State Selected as Chandigarh, the City dropdown Should be disabled to Select.
search_string: PL_2407
*/

/*
Author: Vinod
Date: 17/01//2020
Issue Description: Unable to Create Location when Lwf unchecked, It Displaying as Lwf pincode Mandatory
search_string: PL_2455
*/

/*
Author: Vinod
Date: 24/01//2020
Issue Description: In LWF Pincode Field Displaying Undefined.
search_string: PL_2530
*/

/*
Author: Vinod
Date: 17/03/2020
Issue Description: Not getting error message, although it's a mandatory field.
search_string: PL_2945
*/

/*
Author: Vinod
Date: 20/03/2020
Issue Description: LWF Address line 2, not a mandatory field, In UI it is showing as mandatory field.
search_string: PL_2966
*/

/*
Author: Shivakumar
Date: 27/03/2020
Issue Description: LWF Address in Create Location
search_string: PL_2557
*/

/*
Author: Vinod
Date: 13/04/2020
Issue Description: Validation Error Message was not showing under State / Union Teritory Drop Down.
search_string: PL_3056
*/
<template>
  <div>
    <div class="top-bar">
      <img @click="goBackToLocationPage" src="@/assets/path-2-copy.png" />
      <span class="heading_new">{{ heading }}</span>
    </div>
    <div class="content-new">
      <div class="row" v-if="!editMode">
        <div>
          <tl-radio
            name="uploadMethod"
            label="Bulk Upload"
            id="bulkUpload"
            value="bulkUpload"
            v-model="uploadMethod"
          />
        </div>
        <div class="col-3">
          <tl-radio
            name="uploadMethod"
            label="Manual"
            id="manualUpload"
            value="manualUpload"
            v-model="uploadMethod"
          />
        </div>
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="row" v-if="uploadMethod == 'bulkUpload'">
        <div class="col-12 margintop-32">
          <download-button
            @downloadTemplate="downloadTemplate"
          ></download-button>
        </div>
        <div class="col-12 margintop-16">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>
      <div v-else class="margintop-24">
        <div class="row">
          <txt
            autofocus="autofocus"
            label="Location Name *"
            type="text"
            v-model="formData.name"
            name="Location Name"
            v-validate="{required: true, max: nameMaxlength}"
            :classname="errors.has('Location Name')"
            :errormsg="errors.first('Location Name')"
          ></txt>
          <tl-select
            class="customwidth"
            name="Industry Type"
            labelText="name"
            label="Industry Type"
            :options="industrytype"
            v-model="industryTypeObj"
            @change="(val)=>industryTypeObj=val"
            v-validate="{required: false}"
            :classname="errors.has('Industry Type')"
            :errormsg="errors.first('Industry Type')"
          ></tl-select>
        </div>
        <div class="row headerClass margintop-32">Address</div>
        <div class="row twoColumnGrid margintop-24">
          <txt
            class="adress"
            name="addresLine1"
            label="Address Line 1"
            type="text"
            v-model="formData.address.addressLineOne"
            @change="(val)=>{formData.address.addressLineOne=val;(formData.lwf_applicable && formData.sameAsLocationAddress) ? formData.lwfaddressLineOne=val:'';}"
            v-validate="{required: false, max:250}"
            data-vv-as="Address Line 1"
            :classname="errors.has('addresLine1')"
            :errormsg="errors.first('addresLine1')"
          ></txt>
          <txt
            class="streetNum"
            name="addresLine2"
            label="Address Line 2"
            type="text"
            v-model="formData.address.addressLineTwo"
            @change="(val)=>{formData.address.addressLineTwo=val;(formData.lwf_applicable && formData.sameAsLocationAddress) ? formData.lwfaddressLineTwo=val:'';}"
            v-validate="{required: false, max:250}"
            data-vv-as="Address Line 2"
            :classname="errors.has('addresLine2')"
            :errormsg="errors.first('addresLine2')"
          ></txt>
        </div>
        <div class="row twoColumnGrid margintop-24">
          <div>
            <tl-select
              name="State"
              label="State / Union Territory *"
              labelText="state_name"
              class="customwidth"
              :options="globalData.State"
              v-model="formData.stateObj"
              @change="(val)=>{formData.stateObj = val; formData.cityObj=''; onLocationStateChange(val);}"
              v-validate="{required: true}"
              data-vv-as="State / Union Territory"
              :classname="errors.has('State')"
              :errormsg="errors.first('State')"
            ></tl-select>
          </div>
          <div>
            <tl-select
              name="City"
              label="City *"
              class="customwidth"
              labelText="city_name"
              :options="formData.stateObj ? formData.stateObj.City:[]"
              v-model="formData.cityObj"
              @change="(val)=>{formData.cityObj = val;(formData.lwf_applicable && formData.sameAsLocationAddress ) ? formData.lwfcityObj=val:'';}"
              v-validate="{required:true}"
              :classname="errors.has('City')"
              :errormsg="errors.first('City')"
            ></tl-select>
          </div>
        </div>
        <div class="row margintop-24">
          <div>
            <tl-select
              class="customwidth"
              label="Country"
              name="dispatchCountry"
              labelText="name"
              :options="countriesListArray"
              :disable="true"
              v-model="formData.countryObj"
            ></tl-select>
          </div>
          <div>
            <!-- Start PL_2027 -->
            <txt
              class="pincode adjust"
              label="Pincode "
              type="text"
              name="pincode"
              v-numeric-only
              maxlength="6"
              v-model="formData.address.pincode"
              @change="(val)=>{formData.address.pincode = val;(formData.lwf_applicable && formData.sameAsLocationAddress) ? formData.lwfpincode=val:'';}"
              v-validate="{required:false}"
              data-vv-as="Pincode"
              :classname="errors.has('pincode')"
              :errormsg="errors.first('pincode')"
            ></txt>
            <!-- End PL_2027 -->
          </div>
        </div>
        <div class="row headerClass margintop-24">Statutory Settings</div>
        <div class>
          <div class="row subheaderClass margintop-32">LWF Settings</div>
          <div class="row margintop-24">
            <tl-checkbox
              label="Welfare Fund Applicable"
              v-model="formData.lwf_applicable"
              @change="onChangeLWFApplicable($event)"
              ref="welfareFundApplicable"
              data-vv-as="Welfare Fund Applicable"
            />
          </div>
          <div
            class="row padding-l-15px margintop-24"
            v-if="(formData.stateObj ? formData.stateObj.state_name == 'Kerala':'') && formData.lwf_applicable"
          >
            <div class="col-1">
              <tl-radio
                name="keralawelfare"
                label="LWF"
                id="lwf"
                :value="false"
                v-model="formData.wwf_applicable"
              />
            </div>
            <div class="col-1">
              <tl-radio
                name="keralawelfare"
                label="WWF"
                id="wwf"
                :value="true"
                v-model="formData.wwf_applicable"
              />
            </div>
          </div>

          <div v-if="formData.lwf_applicable" class="row margintop-24">
            <tl-checkbox
              label="Same as location address"
              v-model="formData.sameAsLocationAddress"
              ref="sameAsLocationAddress"
              @change="(bool)=>{changeSameAsLocationAddressCheckbox(bool)}"
              :disabled="!(formData.stateObj && formData.stateObj.lwf_applicable)"
            />
          </div>
          <div class="row subheaderClass margintop-24" v-if="formData.lwf_applicable">Address</div>
          <div class="marginbottom-32" v-show="formData.lwf_applicable">
            <div class="row">
              <txt
                class="address"
                name="lwfaddresLineOne"
                label="Address Line 1"
                type="text"
                v-model="formData.lwfaddressLineOne"
                data-vv-as="address line 1"
                v-validate="{required: false, max:250}"
                :classname="errors.has('lwfaddresLineOne')"
                :errormsg="errors.first('lwfaddresLineOne')"
              ></txt>
              <!-- v-validate="'required_if:welfareFundApplicable,true'" -->
              <!-- PL_2966 -->
              <txt
                class="streetNum"
                name="lwfaddresLineTwo"
                label="Address Line 2"
                type="text"
                v-model="formData.lwfaddressLineTwo"
                data-vv-as="address line 2"
                v-validate="{required: false, max:250}"
                :classname="errors.has('lwfaddresLineTwo')"
                :errormsg="errors.first('lwfaddresLineTwo')"
              ></txt>
              <!-- v-validate="'required_if:welfareFundApplicable,true'" -->
            </div>
            <div class="row margintop-24 twoColumnGrid">
              <!-- Start PL_2335 -->
              <tl-select
                label="State / Union Territory *"
                labelText="state_name"
                class="customwidth"
                :options="globalData.LWFState"
                v-model="formData.lwfstateObj"
                @change="(val) => {formData.lwfstateObj = val; formData.lwfcityObj=''; onLWFStateChange(val); }"
                name="LWF State / Union Territory"
                data-vv-as="State / Union Territory"
                v-validate="'required_if:welfareFundApplicable,true'"
                :classname="errors.has('LWF State / Union Territory')"
                :errormsg="errors.first('LWF State / Union Territory')"
              ></tl-select>
              <!-- End PL_2335 -->
              <!-- PL_2407 -->
              <tl-select
                label="City *"
                class="customwidth"
                labelText="city_name"
                :options="formData.lwfstateObj ? formData.lwfstateObj.City:[]"
                v-model="formData.lwfcityObj"
                @change="(val) => formData.lwfcityObj = val"
                name="Lwf City"
                data-vv-as="City"
                v-validate="{required: (formData.lwf_applicable && formData.lwfstateObj && formData.lwfstateObj.City && formData.lwfstateObj.City.length) ? true:false}"
                :classname="errors.has('Lwf City')"
                :errormsg="errors.first('Lwf City')"
              ></tl-select>
            </div>
            <div class="row twoColumnGrid margintop-24">
              <tl-select
                class="customwidth"
                label="Country"
                name="dispatchCountry"
                labelText="name"
                :options="countriesListArray"
                :disable="true"
                v-model="formData.lwfCountryObj"
              ></tl-select>
              <!-- Start PL_2027 , PL_2353, PL_2455-->
              <txt
                label="Pincode "
                type="text"
                name="lwfpincode"
                data-vv-as="Pincode"
                v-numeric-only
                maxlength="6"
                v-model="formData.lwfpincode"
                v-validate="{required:false}"
                :classname="errors.has('lwfpincode')"
                :errormsg="errors.first('lwfpincode')"
              />
              <!-- End PL_2027, PL_2353, PL_2455 -->
            </div>
            <div class="row margintop-24" v-show="formData.lwf_applicable">
              <tl-select
                name="deductionFrequency"
                labelText="name"
                class="customwidth"
                label="Deduction Frequency *"
                :options="deductionFrequencyOptions"
                v-model="formData.deductionFrequency"
                data-vv-as="Deduction Frequency"
                v-validate="'required_if:welfareFundApplicable,true'"
                 :disabled="true"
                @change="(val)=>formData.deductionFrequency=val"
                :classname="errors.has('deductionFrequency')"
                :errormsg="errors.first('deductionFrequency')"

              ></tl-select>

            </div>
            <div class="row margintop-24">
              <txt
                autofocus="autofocus"
                label="Signatory Name"
                type="text"
                v-model="formData.signatoryName"
                name="SignatoryName"
              ></txt>
              <txt
                autofocus="autofocus"
                label="Designation"
                type="text"
                v-model="formData.designation"
                name="designation"
              ></txt>
            </div>
          </div>
          <br />
          <br />
        </div>

        <div
          :class="{'row margintop-64 subheaderClass': formData.lwf_applicable, 'row subheaderClass': !formData.lwf_applicable}"
          class="row subheaderClass"
        >ESI Settings</div>
        <div class="row margintop-24">
          <tl-checkbox
            label="ESI Applicable"
            @change="(val)=>esiApplicable(val)"
            v-model="formData.esiApplicable"
            :checked="formData.esiApplicable"
          />
        </div>
        <div class="col-12 padding-l-n" v-if="formData.esiApplicable">
          <div class="row esiClass margintop-24">
            <tl-radio
              v-show="false"
              name="esiSetting"
              label="Standard Contribution"
              id="standard"
              :value="true"
              v-model="formData.standardESIContribution"
              @change="esiSettingsChange($event)"
              :checked="formData.standardESIContribution"
            />
            <tl-radio
              v-show="false"
              name="esiSetting"
              label="Reduced Contribution"
              id="reduced"
              :value="false"
              @change="esiSettingsChange($event)"
              v-model="formData.standardESIContribution"
              :checked="formData.standardESIContribution"
            />
          </div>
          <div class="row margintop-16">
            <div class="grey-rect" v-if="formData.standardESIContribution">
              <p class="margin-b-m">Employee ESI Contribution = 1.75% of ESI Wage</p>
              <p>Employer ESI Contribution = 4.75% of ESI Wage</p>
            </div>
            <div class="grey-rect" v-if="!formData.standardESIContribution">
              <p class="margin-b-m">Employer ESI Contribution = 3.25% of ESI Wage</p>
              <p>Employee ESI Contribution = 0.75 % of ESI Wage</p>
            </div>
          </div>
        </div>

        <!-- <div class="row subheaderClass margin-t-l">Minimum Wage Settings</div>
        <tl-select
          class="margin-t-25px"
          name="minimumWageZone"
          labelText="name"
          label="Minimum Wage Zone *"
          :options="globalData.MinimumWageZone"
          v-model="formData.minimumWageZoneObj"
          v-validate="'required'"
          data-vv-as="Minimum Wage Zone"
          @change="(val)=>formData.minimumWageZoneObj=val"
          :classname="errors.has('minimumWageZone')"
          :errormsg="errors.first('minimumWageZone')"
        ></tl-select>
        <span class="col-12 padding-l-n input-label margintop-24">Wages Calculated On</span>
        <div class="col-12 padding-l-n margin-t-s">
          <div class="row">
            <tl-radio
              v-if="formData.stateObj && formData.stateObj.state_name == 'Maharashtra'"
              name="wageType"
              label="Basic + DA + HRA "
              id="basic"
              value="BDA"
              v-model="formData.minimumWageSalaryType"
              :checked="formData.minimumWageSalaryType"
            />
            <tl-radio
              name="wageType"
              v-else
              label="Basic + DA "
              id="basic"
              value="BDA"
              v-model="formData.minimumWageSalaryType"
              :checked="formData.minimumWageSalaryType"
            />
            <tl-radio
              name="wageType"
              label="Fixed Gross Salary "
              id="fixedGross"
              value="Gross"
              v-model="formData.minimumWageSalaryType"
              :checked="formData.minimumWageSalaryType"
            />
          </div>
        </div>

        <div class="col-12 padding-l-n margintop-24">
          <tl-checkbox
            label="Same for all employees"
            @change="(val)=>sameForAll(val)"
            v-model="formData.minimumWageSame"
            :checked="formData.minimumWageSame"
          />
        </div> -->

        <div class="col-12 padding-l-n subheaderClass margintop-32">Professional Tax Settings</div>
        <div class="col-12 padding-l-n margintop-24">
          <tl-checkbox
            label="PT Applicable"
            v-model="formData.professionalTaxApplicable"
            @change="(val)=>PtApplicable(val)"
            ref="PTApplicable"
            data-vv-as="PT Applicable"
          />
        </div>
        <div v-show="formData.professionalTaxApplicable">
          <tl-select
            class="margintop-24"
            name="ptState"
            labelText="display_name"
            label="State / Union Teritory *"
            :options="globalData.PTState"
            v-model="formData.ptStateObj"
            data-vv-as="State / Union Territory"
            v-validate="'required_if:PTApplicable,true'"
            @change="(val) => {formData.ptStateObj = val; onPtStateChange(val) }"
            :classname="errors.has('ptState')"
            :errormsg="errors.first('ptState')"
          ></tl-select>
          <tl-select
            class="margintop-24"
            name="PTDeductionFrequency"
            labelText="name"
            label="Deduction Frequency *"
            :options="deductionFrequencyOptions"
            v-model="formData.ptdeductionFrequency"
            data-vv-as="Deduction Frequency"
            v-validate="'required_if:PTApplicable,true'"
            @change="(val)=>formData.ptdeductionFrequency=val"
            :disabled="true"
            :classname="errors.has('PTDeductionFrequency')"
            :errormsg="errors.first('PTDeductionFrequency')"
          ></tl-select>

          <div class="row margintop-24">
            <txt
              autofocus="autofocus"
              label="Authorised Signatory"
              type="custom-text"
              v-model="formData.ptsignatoryName"
              name="SignatoryName"
            ></txt>
            <txt
              autofocus="autofocus"
              label="Designation"
              type="text"
              v-model="formData.ptdesignation"
              name="designation"
            ></txt>
          </div>
        </div>
      </div>

      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To Locations"
        @back="goBackToLocationPage"
      ></pop-up-message>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Location ${formData.name} has been successfully ${editMode ? 'updated' : 'created'}.`"
        btnText="Back To Locations"
        @back="goBackToLocationPage"
      />

      <toast-message :message="errmsg" v-show="toast" type="error" />
    </div>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="cancelLocation" />
          <btn :text="btnText" type="primary" @click="saveLocation" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { selectMixin } from "@/mixins/selectMixin";
import * as config from "@/apis/config.js";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "AddLocation",
  mixins: [selectMixin],
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_LOCATIONS,
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      pincodeRegex: null,
      uploadMethod: "manualUpload",
      countriesListArray: [],
      citiesListArray: [],
      lwfcitiesListArray: [],
      industryRegType: [],
      industrytype: [],
      industryTypeObj: null,
      headerText: "",
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
      formData: {
        id: null,
        address: {
          addressLineOne: "",
          addressLineTwo: "",
          stateObj: null,
          cityObj: null,
          pincode: "",
          countryObj: this.countriesListArray[0]
            ? this.countriesListArray[0]
            : null
        },
        sameAsLocationAddress: false,
        designation: "",
        signatoryName: "",
        welfare_fund: "",
        lwf_applicable: false,
        wwf_applicable: false,
        esiApplicable: true,
        standardESIContribution: false,
        lwfaddressLineOne: "",
        lwfaddressLineTwo: "",
        lwfpincode: "",
        lwfstateObj: null,
        lwfState: "",
        lwfStateID: "",
        lwfcityObj: null,
        lwfcityID: "",
        lwfCountryObj: this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null,
        minimumWageSame: true,
        minimumWageSalaryType: "BDA",
        minimumWageZoneObj: null, // PL_2945
        deductionFrequency: "",
        ptdeductionFrequency: "",
        ptApplicable: false,
        ptdesignation: "",
        ptsignatoryName: "",
        ptStateObj: null, // PL_3056
        ptState: "",
        state: this.getStates,
        professionalTaxApplicable: false,
        wazeZoneObj: null,
        stateObj: null,
        cityObj: null,
        countryObj: this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null
      },
      deductionFrequencyOptions: [
        { name: "Monthly", id: "MONTHLY" },
        { name: "Quarterly", id: "QUARTERLY" },
        { name: "Half Yearly", id: "BI_ANNUALLY" },
        { name: "Yearly", id: "ANNUALLY" }
      ],
      nameMaxlength: null
    };
  },

  computed: {
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
      legalEntityData: state => state.onboard.legal_entities.data
    }),
    ...mapGetters({
      record: "onboard/locations/record",
      editMode: "onboard/locations/editMode",
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    /** To fetch Legal entity ID by uasin query params through store */
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
    /** Fetch data from store to know whether navigation is by editing a Location item or New one */
    editMode() {
      return this.$store.getters["onboard/locations/editMode"];
    },
    /** Fetch edited Location item data from store */
    record() {
      if (this.editMode) {
        return this.$store.getters["onboard/locations/record"];
      }
    },
    /** To set Bottom button text based on conditions */
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New Location";
      }
    },
    /** To set Header text based on conditions */
    heading() {
      if (this.editMode) {
        return "Location - " + this.record.name;
      } else {
        return "Add New Location";
      }
    }
  },
  /** To set Data before the component is created */
  beforeCreate() {
    try {
      this.countriesListArray = config.GlobalList.countriesList;
      this.pincodeRegex = config.Regex.PINCODE;
    } catch (err) {
      this.errmsg = err;
      this.toast = true;
    }
  },

  activated() {
    this.setGlobalValidations();
    this.setGlobalData();
    // Start PL_2023
    this.citiesListArray = [];
    this.lwfcitiesListArray = [];
    // End PL_2023
    this.toast = false;
    this.pincodeRegex = config.Regex.PINCODE;
    if (this.editMode) {
      this.setLocationData();
    } else {
      this.setLocationsDefaultData();
    }
  },

  methods: {
    ...mapActions({
      act_create: "onboard/locations/create",
      act_update: "onboard/locations/update",
      act_download_template: "onboard/downloadTemplate"
    }),

    async downloadTemplate() {
     try {
       let res = await this.act_download_template('location');
     } catch (error) {
       this.toast = true;
       this.errmsg = error;
     }
   },

    setGlobalValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** BULK UPLOAD server call response handling */
    async onUploadTemplate(res) {
      try {
        if (res.data && res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.showSuccessBulkUploadMsg = true;
        } else {
          this.toast = true;
          this.errmsg = res.response.data.message;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to set the Locations default data */
    setLocationsDefaultData() {
      try {
        this.headerText = "Add New Location";
        this.uploadMethod = "manualUpload";
        this.countriesListArray = config.GlobalList.countriesList;
        this.refresh();
        this.setIndustryType(
          this.legalEntityData[this.$route.params.entity_index].IndustryType
            ? this.legalEntityData[this.$route.params.entity_index].IndustryType
                .id
            : null
        );
        this.formData.lwfCountryObj = this.countriesListArray[0];
        this.formData.countryObj = this.countriesListArray[0];
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to set the Location item data on Edit */
    setLocationData() {
      try {
        this.countriesListArray = config.GlobalList.countriesList;
        this.headerText = this.record.name;
        this.lwfType = this.record.lwfStateID ? "State" : "Month";
        this.formData = {
          id: this.record.id,
          name: this.record.name,
          stateID: this.record.address ? this.record.address.stateID : null,
          cityID: this.record.address ? this.record.address.cityID : null,
          address: {
            addressLineOne: this.record.address
              ? this.record.address.addressLineOne
              : null,
            addressLineTwo: this.record.address
              ? this.record.address.addressLineTwo
              : null,
            pincode: this.record.address ? this.record.address.pincode : null
          },
          lwf_applicable: this.record.lwf_applicable,
          lwfStateID: this.record.lwfStateID,
          lwfaddressLineOne: this.record.lwf_address
            ? this.record.lwf_address.addressLineOne
            : null,
          lwfpincode: this.record.lwf_address
            ? this.record.lwf_address.pincode
            : null,
          lwfaddressLineTwo: this.record.lwf_address
            ? this.record.lwf_address.addressLineTwo
            : null,
          sameAsLocationAddress: this.record.sameAsLocationAddress
            ? true
            : false, //PL_2557
          signatoryName: this.record.lwf_signatory_name,
          designation: this.record.lwf_signatory_designation,
          wwf_applicable: this.record.wwf_applicable,
          esiApplicable: this.record.esiApplicable,
          standardESIContribution: false,
          minimumWageSalaryType: this.record.minimumWageSalaryType,
          minimumWageSame: this.record.minimumWageSame,
          professionalTaxApplicable: this.record.pt_applicable,
          ptStateObj: this.setPTState(this.record.ptStateID),
          ptsignatoryName: this.record.pt_signatory_name,
          ptdesignation: this.record.pt_signatory_designation,
          minimumWageZoneObj: this.setMinimumWageZone(
            this.record.minimumWageZoneID
          ),
          industryTypeObj: this.setIndustryType(this.record.industry_type)
        };
        this.formData.lwfCountryObj = this.countriesListArray[0];
        this.formData.countryObj = this.countriesListArray[0];
        this.uploadMethod = "manualUpload";
        this.setStatesAndCities();
        this.setPTdeductionFrequency();
        this.setDeductionFrequency();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the Industry type dropdown data on edit / by default if any */
    setIndustryType(industry_type) {
      try {
        if (industry_type) {
          this.industryTypeObj = this.globalData.IndustryType.find(
            ele => ele.id == industry_type
          );
        } else {
          this.industryTypeObj = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the Minimum zone dropdown data on edit */
    setMinimumWageZone(minimumWageZoneID) {
      try {
        if (minimumWageZoneID) {
          return this.globalData.MinimumWageZone.find(
            ele => ele.id == minimumWageZoneID
          );
        } else {
          return null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the PT deduction frequency data on edit */
    setPTdeductionFrequency() {
      try {
        if (this.record.pt_deduction_frequency) {
          this.formData.ptdeductionFrequency = this.deductionFrequencyOptions.find(
            ele => ele.id == this.record.pt_deduction_frequency
          );
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the LWF Deduction frequency data on edit */
    setDeductionFrequency() {
      try {
        if (this.record.lwf_deduction_frequency) {
          this.formData.deductionFrequency = this.deductionFrequencyOptions.find(
            ele => ele.id == this.record.lwf_deduction_frequency
          );
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the PT State dropdown data on edit */
    setPTState(ptStateID) {
      try {
        if (ptStateID) {
          return this.globalData.PTState.find(ele => ele.id == ptStateID);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To set the State & City dropdown values on edit */
    setStatesAndCities() {
      try {
        if (this.editMode) {
          if (this.record.address) {
            if (this.record.address.cityID) {
              this.formData.stateObj = this.globalData.State.find(
                ele => ele.id == this.record.address.stateID
              );
              this.formData.cityObj = this.formData.stateObj.City.find(
                ele => ele.id == this.record.address.cityID
              );
            }
          }
          if (this.record.lwf_address) {
            if (this.record.lwf_address.stateID) {
              this.formData.lwfstateObj = this.globalData.State.find(
                ele => ele.id == this.record.lwf_address.stateID
              );
              this.formData.lwfcityObj = this.formData.lwfstateObj.City.find(
                ele => ele.id == this.record.lwf_address.cityID
              );
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Function to set the Dropdown values from the Global data */
    async setGlobalData() {
      try {
        let obj = this.globalData;
        this.industrytype = obj.IndustryType;
        this.industryregtype = obj.IndustryRegistrationType;
        this.state = obj.State;
        this.formData.minimumWageZoneObj = this.globalData.MinimumWageZone[0];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Navigation to go to Locations list screen */
    goBackToLocationPage() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
      });
      this.showSuccessMsg = false;
      this.showSuccessBulkUploadMsg = false;
      this.refresh();
    },

    /** On Location State dropdown click */
    // PL_2557
    onLocationStateChange(val) {
      if (!(val && val.lwf_applicable)) {
        this.formData.sameAsLocationAddress = false;
      } else {
        if (this.formData.lwf_applicable) {
          this.formData.lwfstateObj = val;
          this.formData.lwfcityObj = null;
        }
      }
      this.formData.lwfstateObj = (formData.lwf_applicable && formData.sameAsLocationAddress ) ? val:'';
    },
    // PL_2557

    /** On LWF Checkbox click */
    // PL_2557
    onChangeLWFApplicable(value) {
      try {
        if (!value) {
          this.formData.lwfaddressLineOne = null;
          this.formData.lwfaddressLineTwo = null;
          this.formData.lwfstateObj = null;
          this.formData.lwfcityObj = null;
          this.formData.lwfpincode = null;
          this.formData.deductionFrequency = null;
          this.formData.signatoryName = null;
          this.formData.designation = null;
          this.formData.lwfState = null;
        } else {
          if (
            this.formData.stateObj &&
            this.formData.stateObj.lwf_applicable &&
            this.formData.lwf_applicable &&
            this.formData.sameAsLocationAddress
          ) {
            this.formData.lwfstateObj = this.formData.stateObj
              ? this.formData.stateObj
              : null;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // PL_2557

    /** On Same as Location address Checkbox click */
    changeSameAsLocationAddressCheckbox(val) {
      try {
        if (val) {
          this.formData.lwfaddressLineOne = this.formData.address.addressLineOne;
          this.formData.lwfaddressLineTwo = this.formData.address.addressLineTwo;
          this.formData.lwfstateObj = this.formData.stateObj;
          this.formData.lwfcityObj = this.formData.cityObj;
          this.formData.lwfpincode = this.formData.address.pincode;
        } else {
          this.formData.lwfaddressLineOne = "";
          this.formData.lwfaddressLineTwo = "";
          this.formData.lwfstateObj = null;
          this.formData.lwfcityObj = null;
          this.formData.lwfpincode = null;
        }
        this.onLWFStateChange(this.formData.lwfstateObj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** On PT State Dropdown click */
    onPtStateChange(value) {
      try {
        if (value && value.rule && value.rule.frequency) {
          switch (value.rule.frequency) {
            case 1:
              this.formData.ptdeductionFrequency = this.deductionFrequencyOptions[0];
              break;
            case 3:
              this.formData.ptdeductionFrequency = this.deductionFrequencyOptions[1];
              break;
            case 6:
              this.formData.ptdeductionFrequency = this.deductionFrequencyOptions[2];
              break;
            case 12:
              this.formData.ptdeductionFrequency = this.deductionFrequencyOptions[3];
              break;
            default:
              break;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   onLWFStateChange(value) {
      try {
        if (value && value.lwf_rule && value.lwf_rule.frequency) {
          switch (value.lwf_rule.frequency) {
            case 1:
              this.formData.deductionFrequency = this.deductionFrequencyOptions[0];
              break;
            case 3:
              this.formData.deductionFrequency = this.deductionFrequencyOptions[1];
              break;
            case 6:
              this.formData.deductionFrequency = this.deductionFrequencyOptions[2];
              break;
            case 12:
              this.formData.deductionFrequency = this.deductionFrequencyOptions[3];
              break;
            default:
              break;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On ESI Settings Radio button changes */
    esiSettingsChange(val) {
      try {
        if (val == "true") {
          this.formData.standardESIContribution = true;
        } else {
          this.formData.standardESIContribution = false;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** To reset the form */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.$validator.reset();
        (this.lwfType = ""),
          (this.industryTypeObj = null),
          (this.formData = {
            id: null,
            address: {
              addressLineOne: "",
              addressLineTwo: "",
              stateObj: null,
              cityObj: null,
              pincode: ""
            },
            sameAsLocationAddress: false,
            designation: "",
            signatoryName: "",
            welfare_fund: "",
            lwf_applicable: false,
            wwf_applicable: false,
            esiApplicable: true,
            standardESIContribution: false,
            lwfaddressLineOne: "",
            lwfaddressLineTwo: "",
            lwfpincode: "",
            lwfstateObj: null,
            lwfState: "",
            lwfStateID: "",
            lwfcityObj: null,
            lwfcityID: "",
            lwfCountryObj: this.countriesListArray[0],
            minimumWageSame: true,
            minimumWageSalaryType: "BDA",
            minimumWageZoneObj: null, // PL_2945
            deductionFrequency: "",
            ptdeductionFrequency: "",
            ptApplicable: false,
            ptdesignation: "",
            ptsignatoryName: "",
            ptStateObj: null, // PL_3056
            ptState: "",
            state: this.getStates,
            professionalTaxApplicable: false,
            wazeZoneObj: null,
            stateObj: null,
            cityObj: null,
            countryObj: this.countriesListArray[0]
          });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Navigation to previous screen */
    cancelLocation() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
      });
    },

    /** On PT applicable check box click */
    PtApplicable(val) {
      try {
        this.professionalTaxApplicable = val;
        if (!val) {
          this.formData.ptStateObj = null;
          this.formData.ptdeductionFrequency = null;
          this.formData.ptsignatoryName = null;
          this.formData.ptdesignation = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On Same for all employees check box click */
    sameForAll(val) {
      try {
        if (val) {
          this.sameForAllEmployees = "Yes";
        } else {
          this.sameForAllEmployees = "No";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On ESI applicable check box click */
    esiApplicable(val) {
      try {
        if (val) {
          this.esiApplicableEmployees = "Yes";
        } else {
          this.esiApplicableEmployees = "No";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
        let obj = {
          data: {
            le_id: this.le_id,
            name: this.formData.name.toString().trim(),
            industry_type: this.industryTypeObj
              ? this.industryTypeObj.id
              : null,
            address: {
              addressLineOne: this.formData.address.addressLineOne,
              addressLineTwo: this.formData.address.addressLineTwo,
              cityID: this.formData.cityObj ? this.formData.cityObj.id : null,
              city_name: this.formData.cityObj
                ? this.formData.cityObj.city_name
                : null,
              stateID: this.formData.stateObj.id,
              state_name: this.formData.stateObj.state_name,
              pincode: this.formData.address.pincode, // PL_2530
              countryID: this.formData.countryObj
                ? this.formData.countryObj.id
                : null
            },
            lwf_address: {
              addressLineOne: this.formData.lwfaddressLineOne,
              addressLineTwo: this.formData.lwfaddressLineTwo,
              cityID: this.formData.lwfcityObj
                ? this.formData.lwfcityObj.id
                : null,
              stateID: this.formData.lwfstateObj
                ? this.formData.lwfstateObj.id
                : null,
              state_name: this.formData.lwfstateObj
                ? this.formData.lwfstateObj.state_name
                : "",
              pincode: this.formData.lwfpincode, // PL_2530,
              countryID: this.formData.lwfCountryObj
                ? this.formData.lwfCountryObj.id
                : null
            },
            sameAsLocationAddress: this.formData.sameAsLocationAddress, //PL_2559
            lwf_applicable: this.formData.lwf_applicable,
            wwf_applicable: this.formData.wwf_applicable ? true : false,
            lwfStateID: this.formData.lwfstateObj
              ? this.formData.lwfstateObj.id
              : null, //this.formData.lwfStateID,
            lwf_signatory_name: this.formData.signatoryName,
            lwf_signatory_designation: this.formData.designation,
            lwf_deduction_frequency: this.formData.deductionFrequency
              ? this.formData.deductionFrequency.id
              : null, // PL_2022
            esiApplicable: this.formData.esiApplicable,
            standardESIContribution: this.formData.standardESIContribution,
            pt_signatory_designation: this.formData.ptdesignation,
            pt_signatory_name: this.formData.ptsignatoryName,
            pt_deduction_frequency: this.formData.ptdeductionFrequency
              ? this.formData.ptdeductionFrequency.id
              : null,
            pt_applicable: this.formData.professionalTaxApplicable,
            ptStateID:
              this.formData.professionalTaxApplicable &&
              this.formData.ptStateObj
                ? this.formData.ptStateObj.id
                : null,
            minimumWageZoneID: this.formData.minimumWageZoneObj
              ? this.formData.minimumWageZoneObj.id
              : null,
            minimumWageSame: this.formData.minimumWageSame,
            minimumWageSalaryType: this.formData.minimumWageSalaryType
          }
        };
        this.$root._data.isSaving = true;
        let res = null;
        if (this.editMode) {
          obj.data["id"] = this.record.id;
          res = await this.act_update([obj, this.le_id]);
        } else {
          res = await this.act_create(obj);
        }
        if (res.data.status) {
          this.showSuccessMsg = true;
          this.$root._data.isSaving = false;
        }
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** On Save button click to validate the form */
    saveLocation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formData.minimumWageZoneObj = this.globalData.MinimumWageZone[0];
          this.performAction();
        } else {
          // PL- 1872(If we click next without filling mandatory field, the screen should take you to that field) -02/12/2019

          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.adjust{
  margin-left: 22px;
}
.content-new {
  padding: 32px 32px;
  margin-bottom: 100px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

.top-bar {
  height: 64px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.headerClass {
  margin-bottom: 1.3%;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
.subheaderClass {
  margin-bottom: 1.3%;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

.esiClass {
  display: flex;
}
.grey-rect {
  width: 100%;
  background-color: #f1f1f1;
  padding: 12px 0 0 23px;
  p {
    font-size: 12px;
    font-weight: 500;
    color: #404040;
  }
}
.input-label {
  font-size: 14px;
}
.customwidth {
  width: 300px;
  margin-right: 32px;
}
</style>
